
import React from "react"; 
import { Select } from "antd";
import Breadcrumb from "../Breadcrumb";
import useFetch from "../../../../commons/useFetch";
function Filter(props) {
  const { Option } = Select;

  const {data : destinations}=useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/destinations/')
  return (
    <div className="filterHotels">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-12">
            <Breadcrumb />
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="formLocation">
              <Select
                onChange={(value) => props.onChangeHotels(value)}
                placeholder="Chọn địa điểm"
              >
                <Option>Tất cả</Option>
                {destinations && destinations.map((option) => (
                  <Option value={option.id} key={option.id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Filter;
